
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/live-music",
      function () {
        return require("private-next-pages/live-music/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/live-music"])
      });
    }
  